<style type="text/css" media="screen" scoped>
.add-image-btn{
	height: 138px;
	width: 185px;
	border-radius: 30px;
	display: table-cell;
	vertical-align: middle;
	text-align: center;
	border: 2px solid rgba(0, 0, 0, 0.12);
	box-shadow: 0px 5px 10px 0px rgba(157, 149, 149, 0.25);
}	

.dashboard-image-box{
	height: 138px;
	width: 185px;
	border-radius: 30px;
	box-shadow: 0px 5px 10px 0px rgba(157, 149, 149, 0.25);
	border: 2px solid rgba(0, 0, 0, 0.12);
}
.delete-image-btn{
	position: absolute;
	right: 33px;
	top: 5px
}
.image_wraper{
	position: relative;
}
.add-image-icon-div{
	height: 40px;
	width: 40px;
	border-radius: 50%;
	background-color: #A7A7A7;
	display: table-cell;
	text-align: center;
	vertical-align: middle;
	margin-left:60px 
}

</style>

<template>
	<div>
		<v-row class="">
			<v-col md="3" class="">
				<label class="cursor-pointer ">
					<input  type="file" ref="files" 
					@change="browseFile($event)"
					:accept="$keys.ACCEPTED_IMAGE_FORMATE"  hidden >
					<div class="add-image-btn">
						<v-btn color="#A7A7A7" fab small depressed   disabled>	
							<v-icon color="#ffff">mdi-plus</v-icon>
						</v-btn>
					</div>
				</label>
			</v-col>

			<v-col md="3" v-for="(image,i) in dashboard_image_list" :key="i">
				<div class="image_wraper">
					<v-btn  x-small  fab color="#fff" class="delete-image-btn" @click="ConfirmDeleteImage(image.id)" >
						<img src="@/assets/delete-red.svg" alt="">
					</v-btn>
					<img :src="image.image_url" alt="img" class="dashboard-image-box cursor-pointer" 
					@click="openImageViewer(image.image_url)">
				</div>
			</v-col>

		</v-row>

		<!-- confirmation dialog -->
		<confirm-delete-dialog :dialog="dialog" :deleteImage="deleteImage"/>

		<!-- Image viewer -->
		<image-viewer :image_src="image_viewer_url"/>


	</div>
</template>
<script type="text/javascript">
export default{
	components: {
		ConfirmDeleteDialog:()=> import('./child/ConfirmDeleteDialog.vue'),
		ImageViewer :()=>import('@/components/common-components/ImageViewer.vue'),

	},
	data(){
		return{
			dashboard_image_list:[],
			btn_loading:false,
			dialog:{
				flag:false,
				id:"",
				btn_loading:false,
			},

			is_reatiler_image:false,
			create_url:"",
			delete_url:"",
			get_image_list_url:"",
			image_viewer_url:"",

		}
	},
	mounted(){
		console.log(this.$route.name)
		if(this.$route.name!="wholesaler-offer-image"){
			this.is_reatiler_image=true
		}
		this.getImageList()
		this.$store.dispatch('setPageLoader', true)
	},
	methods:{
		/* Fetching the image list from the API Call*/
		getImageList(){
			const self=this
			console.log("Amit sahu")
			let  url=self.$urls.GET_WHOLESALER_DASHBOARD_IMAGES
			if (self.is_reatiler_image)
				url=self.$urls.GET_RETAILER_DASHBOARD_IMAGES


			let params={};
			const successHandler = (response) => {
				if(response.data.success)
					self.dashboard_image_list=response.data.dashboard_image_list.reverse()

			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)

			};
			self.request_GET( self,url,params,successHandler,null,null,finallyHandler)
		},
		/* Browse Image and validate image */
		browseFile(e){
			const self= this		

			if(!this.$keys.ACCEPTED_IMAGE_FORMATE.includes(e.target.files[0]['type'])){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
				return false;
			}
			if(e.target.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
				return false;
			}

			this.haldleImageUpload(e.target.files[0]);
			e.target.files[0]=null

		},
		/* upload image*/ 
		haldleImageUpload(image){
			const self= this
			this.$store.dispatch('setPageLoader', true)
			var	form = new FormData();

			let  url=self.$urls.CREATE_WHOLESALER_DASHBOARD_IMAGES
			if (self.is_reatiler_image){
				url=self.$urls.CREATE_RETAILER_DASHBOARD_IMAGES
				form.append("retailer_dashboard_image",image)  
			}
			else{
				form.append("wholesaler_dashboard_image",image)  

			}




			const successHandler = (response) => {
				if (response.data.success){
					self.showSnakeBar("success",response.data.message)
					self.getImageList()
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
			};

			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)
		},
		ConfirmDeleteImage(id){
			this.dialog.flag=true
			this.dialog.id=id
		},
		/* Delete Image */ 
		deleteImage(){
			const self=this
			this.dialog.btn_loading=true


			let  url=self.$urls.DELETE_WHOLESALER_DASHBOARD_IMAGES
			if (self.is_reatiler_image)
				url=self.$urls.DELETE_RETAILER_DASHBOARD_IMAGES


			let params={
				id:this.dialog.id
			};
			const successHandler = (response) => {
				if(response.data.success){
					this.dialog.flag=false
					self.getImageList()
				}

			};
			const finallyHandler = () => {
				this.dialog.btn_loading=false

			};
			self.request_GET( self,url,params,successHandler,null,null,finallyHandler)
		},
		/* Open Image viewer */ 
		openImageViewer(image_url){
			this.image_viewer_url=image_url
			this.$store.dispatch('setImageViewer',true)
		}
	}


}
</script>